import { render, staticRenderFns } from "./pt-sub-title-tab.vue?vue&type=template&id=3fbf0de0"
import script from "./pt-sub-title-tab.vue?vue&type=script&lang=js"
export * from "./pt-sub-title-tab.vue?vue&type=script&lang=js"
import style0 from "./pt-sub-title-tab.vue?vue&type=style&index=0&id=3fbf0de0&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports